import Swiper from 'swiper';
import axios from 'axios';

export default class Drawer {

    constructor() {
        this.outer = new Swiper('.outer-swiper', {
            direction: 'vertical',
            spaceBetween: 50,
            allowTouchMove: false
        });
    }

    fetch(url) {
        axios.get('./'+url).then((response) => {
            if(response.data.content){

                let content = response.data.content,
                    isOpen = document.getElementById("sidebar").classList.contains('open');

                this.outer.appendSlide('<div class="swiper-slide">'+content+'</div>');
                this.outer.update();
                this.outer.slideNext();

                if(response.data.js && typeof response.data.js == 'object'){
                    response.data.js.forEach((script)=>{
                        (new Function(script)).call(response.data);
                    });
                }

                setTimeout(() => {
                    this.outer.removeSlide(0);
                    this.outer.update();
                    window.App.common.init(this.outer.$el[0]);
                }, 100)

                if(!isOpen){
                    document.getElementById("sidebar").classList.add('open');
                    document.body.classList.add('bodyoverlay');
                }

                document.querySelectorAll('#sidebar>nav>button').forEach(node => {
                    node.classList.remove('active');
                });
            }
        });
    }

    open(el) {
        
        const modal = document.getElementById("uzayModal");
        if(modal){
            modal.remove();
        }

        var url = (el.getAttribute('data-drawer')||'cart'),
            target = (el.getAttribute('data-drawer-target')||'outer'),
            hasInnerSwiper = (el.getAttribute('data-drawer-has-inner-swiper')?true:false),
            direction = (el.getAttribute('data-drawer-direction')||'next'),
            isOpen = document.getElementById("sidebar").classList.contains('open'),
            isElSidebarButton = (el.parentNode.parentNode.getAttribute('id') == 'sidebar'?true:false),
            sbButton = (el.getAttribute('data-drawer-sbbutton')||null);
        
        if(isElSidebarButton){
            var currIndex = Array.from(document.querySelectorAll('#sidebar>nav>button')).indexOf(document.querySelector('#sidebar>nav>button.active')),
                nextIndex = Array.from(document.querySelectorAll('#sidebar>nav>button')).indexOf(el);
            
            if(currIndex==nextIndex){return false;}
            if(currIndex>nextIndex){direction='prev';}
        }

        if(target=='outer'){
            if (this.inner && typeof this.inner.destroy === "function") {
                this.inner.destroy();
            }
            this.inner = null;
        }

        axios.get('./'+url).then((response) => {
            if(response.data.content){

                var content = response.data.content;

                if(target=='outer'){
                    if(hasInnerSwiper){
                        let rand = Math.random().toString(36).substring(7);

                        direction=='next'?this.outer.appendSlide('<div class="swiper-slide"><div class="swiper-container inner-swiper inner-swiper-'+rand+'"><div class="swiper-wrapper"><div class="swiper-slide">'+content+'</div></div></div></div>'):this.outer.prependSlide('<div class="swiper-slide"><div class="swiper-container inner-swiper inner-swiper-'+rand+'"><div class="swiper-wrapper"><div class="swiper-slide">'+content+'</div></div></div></div>');
                        this.outer.update();
                        
                        this.inner = new Swiper('.inner-swiper-'+rand, {
                            spaceBetween: 50,
                            allowTouchMove: false
                        });

                        direction=='next'?this.outer.slideNext():this.outer.slidePrev();
                        setTimeout(() => {this.outer.removeSlide(direction=='next'?0:1);this.outer.update();}, 100)
                    }else {
                        direction=='next'?this.outer.appendSlide('<div class="swiper-slide">'+content+'</div>'):this.outer.prependSlide('<div class="swiper-slide">'+content+'</div>');
                        this.outer.update();
                        direction=='next'?this.outer.slideNext():this.outer.slidePrev();
                        setTimeout(() => {this.outer.removeSlide(direction=='next'?0:1);this.outer.update();}, 100)
                    }
                } else {
                    direction=='next'?this.inner.appendSlide('<div class="swiper-slide">'+content+'</div>'):this.inner.prependSlide('<div class="swiper-slide">'+content+'</div>');
                    this.inner.update();
                    direction=='next'?this.inner.slideNext():this.inner.slidePrev();
                    setTimeout(() => {this.inner.removeSlide(direction=='next'?0:1);this.inner.update();}, 100)
                }

                if(!isOpen){
                    document.getElementById("sidebar").classList.add('open');
                    document.body.classList.add('bodyoverlay');
                }

                if(response.data.js && typeof response.data.js == 'object'){
                    response.data.js.forEach((script)=>{
                        (new Function(script)).call(response.data);
                    });
                }

                window.App.common.init(this.outer.$el[0]);

                if(isElSidebarButton){
                    document.querySelectorAll('#sidebar>nav>button').forEach(node => {
                        if(node!=el)
                           node.classList.remove('active');
                    });
                    el.classList.add('active');
                }
                if(sbButton) {
                    document.querySelectorAll('#sidebar>nav>button').forEach(node => {
                        if(node!=el)
                           node.classList.remove('active');
                    });
                    document.querySelector(sbButton).classList.add('active');
                }
            }
        });
    }

    close() {
        document.getElementById("sidebar").classList.remove('open');
        document.body.classList.remove('bodyoverlay');

        document.querySelectorAll('[data-drawer]').forEach(function (button) {
            button.classList.remove('active');
        });
    }
}